export const mockFlows = [
  {
    id: '1',
    name: 'Welcome Message',
    status: 'active',
    platform: 'messenger',
    triggers: 3,
    subscribers: 1234,
    lastModified: '2025-01-15',
    nodes: [
      { id: 'start', type: 'trigger', position: { x: 100, y: 100 }, data: { label: 'Welcome Trigger' } },
      { id: '1', type: 'message', position: { x: 100, y: 200 }, data: { label: 'Send Welcome Message', content: 'Hi! Welcome to our service!' } },
      { id: '2', type: 'action', position: { x: 100, y: 300 }, data: { label: 'Tag Subscriber', tag: 'new_user' } }
    ],
    connections: [
      { from: 'start', to: '1' },
      { from: '1', to: '2' }
    ]
  },
  {
    id: '2',
    name: 'Product Launch',
    status: 'active',
    platform: 'instagram',
    triggers: 5,
    subscribers: 2456,
    lastModified: '2025-01-14'
  },
  {
    id: '3',
    name: 'Abandoned Cart',
    status: 'draft',
    platform: 'whatsapp',
    triggers: 2,
    subscribers: 890,
    lastModified: '2025-01-13'
  }
];

export const mockContacts = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john@example.com',
    platform: 'messenger',
    tags: ['customer', 'vip'],
    lastInteraction: '2025-01-15T10:30:00',
    status: 'subscribed'
  },
  {
    id: '2',
    name: 'Jane Smith',
    email: 'jane@example.com',
    platform: 'instagram',
    tags: ['lead'],
    lastInteraction: '2025-01-14T15:20:00',
    status: 'subscribed'
  },
  {
    id: '3',
    name: 'Mike Johnson',
    email: 'mike@example.com',
    platform: 'whatsapp',
    tags: ['customer'],
    lastInteraction: '2025-01-13T09:15:00',
    status: 'unsubscribed'
  }
];

export const mockMessages = [
  {
    id: '1',
    contactId: '1',
    contactName: 'John Doe',
    platform: 'messenger',
    messages: [
      { id: 'm1', sender: 'bot', content: 'Hi John! How can I help you today?', timestamp: '2025-01-15T10:30:00' },
      { id: 'm2', sender: 'user', content: 'I need help with my order', timestamp: '2025-01-15T10:31:00' },
      { id: 'm3', sender: 'bot', content: 'I\'d be happy to help! What\'s your order number?', timestamp: '2025-01-15T10:31:30' }
    ],
    unread: 1,
    lastMessage: '2025-01-15T10:31:30'
  },
  {
    id: '2',
    contactId: '2',
    contactName: 'Jane Smith',
    platform: 'instagram',
    messages: [
      { id: 'm4', sender: 'user', content: 'Hello!', timestamp: '2025-01-14T15:20:00' },
      { id: 'm5', sender: 'bot', content: 'Welcome! How can I assist you?', timestamp: '2025-01-14T15:20:15' }
    ],
    unread: 0,
    lastMessage: '2025-01-14T15:20:15'
  }
];

export const mockAnalytics = {
  totalSubscribers: 4580,
  activeFlows: 12,
  messagesSent: 45678,
  openRate: 78.5,
  clickRate: 45.2,
  conversionRate: 12.8,
  growthData: [
    { date: '2025-01-08', subscribers: 3200, messages: 12400 },
    { date: '2025-01-09', subscribers: 3450, messages: 13200 },
    { date: '2025-01-10', subscribers: 3680, messages: 14100 },
    { date: '2025-01-11', subscribers: 3920, messages: 15300 },
    { date: '2025-01-12', subscribers: 4150, messages: 16200 },
    { date: '2025-01-13', subscribers: 4320, messages: 17800 },
    { date: '2025-01-14', subscribers: 4480, messages: 18900 },
    { date: '2025-01-15', subscribers: 4580, messages: 19500 }
  ],
  platformDistribution: [
    { platform: 'Messenger', users: 2340, percentage: 51 },
    { platform: 'Instagram', users: 1450, percentage: 32 },
    { platform: 'WhatsApp', users: 790, percentage: 17 }
  ]
};
